import useSearchParam from "ui/common/hooks/useSearchParam";
import { Updater, UpdaterFn } from "@commonlibs";
import { useEffect, useState } from "react";
import { PaginationState } from "@tanstack/react-table";

export default function useTableSearchParamPagination(pageSize = 30): [PaginationState, UpdaterFn<PaginationState>] {
    const [pageIndex = 1, setPageIndex] = useSearchParam("page", {
        parse: Number,
        validation: (value) => Number.isInteger(Number(value)) && Number(value) > 0,
        fallback: 1,
    });

    const [paginationState, setPaginationState] = useState<PaginationState>({
        pageIndex,
        pageSize,
    });
    useEffect(() => {
        setPaginationState({
            pageIndex,
            pageSize,
        });
    }, [pageSize, pageIndex]);

    const handlePaginationChange: UpdaterFn<PaginationState> = (updater: Updater<PaginationState>) => {
        const state = typeof updater === "function" ? updater(paginationState) : updater;

        setPageIndex(Number.isNaN(state.pageIndex) || state.pageIndex < 1 ? 1 : state.pageIndex + 1);
    };

    return [paginationState, handlePaginationChange];
}
